import { parse } from "graphql";
const CONTENT_TYPES = `
    $applicationName: String
    $baseLocation: String
    $resourceName: String
    $tenantName: String
    $groupName: String
    $folder: String
    $locale: String
`;
const CONTENT_VARS = `
    applicationName: $applicationName
    baseLocation: $baseLocation
    resourceName: $resourceName
    tenantName: $tenantName
    groupName: $groupName
    folder: $folder
    locale: $locale
`;
export const FIND_CONTENT = parse(`
    query findContent(
        ${CONTENT_TYPES}
        $encoding: String
        $ignoreCache: Boolean
        $replaceFieldValue:Boolean
    ) {
        findContent(
            ${CONTENT_VARS}
            encoding: $encoding
            ignoreCache: $ignoreCache
            replaceFieldValue:$replaceFieldValue
        ) {
            contentEncoding
            contentJSON
            fileName
            location
            content
        }
    }
`);
export const DELETE_CONTENT = parse(`
    mutation deleteContent(
        ${CONTENT_TYPES}
    ) {
        deleteContent(
            ${CONTENT_VARS}
        ) {
            successCount
            failureCount
            result
        }
    }
`);
export const saveContentMutation = variables => {
  return parse(`
    mutation saveContent(
        ${CONTENT_TYPES}
        ${variables.contentEncoding ? "$contentEncoding: String" : ""}
        ${variables.contentType ? "$contentType: String" : ""}
        $content: String
    ) {
        saveContent(
            ${CONTENT_VARS}
            ${variables.contentEncoding ? "contentEncoding: $contentEncoding" : ""}
            ${variables.contentType ? "contentType: $contentType" : ""}
            content: $content
        ) {
            successCount
            failureCount
            result
        }
    }
`);
};